const ColorPicker = {
  parts: [
    "area",
    "areaBackground",
    "channelInput",
    "channelInputAlpha",
    "channelSlider",
    "channelSliderThumb",
    "channelSliderTrack",
    "content",
    "eyeDropperTrigger",
    "label",
    "positioner",
    "root",
    "swatch",
    "swatchGroup",
    "swatchTrigger",
    "thumb",
    "transparencyGrid"
  ],
  baseStyle: {
    root: {
      display: "flex"
    },
    label: {
      color: "text-secondary",
      fontSize: "text-sm"
    },
    content: {
      width: "300px",
      height: "296px",
      borderRadius: "md",
      padding: "100",
      bgColor: "white",
      _dark: {
        bgColor: "grayscale.900"
      },
      borderWidth: "1px",
      borderColor: "stroke",
      display: "flex",
      gap: "200",
      flexDirection: "column"
    },
    areaBackground: {
      width: "100%",
      height: "100%",
      borderRadius: "sm"
    },
    area: {
      width: "100%",
      height: "160px",
      borderRadius: "sm"
    },
    channelInput: {
      bgColor: "input-fill",
      height: "sm",
      borderRadius: "sm",
      paddingLeft: "50"
    },
    channelInputAlpha: {
      bgColor: "input-fill",
      height: "sm",
      borderRadius: "sm",
      paddingLeft: "50",
      width: "75px"
    },
    channelSlider: {
      width: "100%",
      height: "11px"
    },
    channelSliderTrack: {
      height: "11px",
      borderRadius: "100px",
      "[data-channel=hue]": {
        bg: "rainbow"
      },
      "[data-channel=alpha]": {
        bg: "linear-gradient(to right, hsla(0, 0%, 0%, 0), hsla(0, 0%, 0%, 1))"
      }
    },
    thumb: {
      width: "2xs",
      height: "2xs",
      borderRadius: "round",
      borderWidth: "2px",
      borderColor: "white",
      transform: "translate(-50%,-50%)"
    },
    channelSliderThumb: {
      width: "2xs",
      height: "2xs",
      borderRadius: "round",
      borderWidth: "2px",
      borderColor: "white",
      transform: "translate(-50%,-50%)"
    },
    transparencyGrid: {
      borderRadius: "100px"
    },
    swatchGroup: {
      display: "flex",
      gap: "50"
    },
    swatchTrigger: {
      borderRadius: "round",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderWidth: "2px",
      borderColor: "transparent",
      "&[data-state=checked]": {
        borderColor: "text-primary"
      }
    },
    swatch: {
      borderRadius: "round",
      borderWidth: "1px",
      borderColor: "stroke",
      borderStyle: "solid",
      cursor: "pointer"
    },
    positioner: {
      // Need to override the inline zindex (auto) that's applied by ark-ui
      zIndex: "popover !important",
      borderRadius: "md",
      backdropFilter: "blur(var(--vimeo-blur-md))",
      "::-moz-backdrop-filter": "blur(var(--vimeo-blur-md))",
      boxShadow: "md"
    }
  }
};

export { ColorPicker };
